import {Dialog, Theme} from "@mui/material";
import {makeStyles} from 'tss-react/mui';
import {FunctionComponent} from "react";
import {useTranslation} from "react-i18next";
import EditComponentTranslationMainView from "@/Components/EditComponentTranslation/Views/EditComponentTranslationMainView";


const useStyles = makeStyles()((theme: Theme) =>
    ({
        dialog: {
            maxHeight: '100%',
            overflowY: 'hidden',
            padding: 6
        }
    }));

interface IEditComponentTranslationOverlayWrapper {
    isOpen: boolean;
    setIsOpen: any;
    node: any;
    lang: string;
    translationValue: any;
}

const EditComponentTranslationOverlayWrapper: FunctionComponent<IEditComponentTranslationOverlayWrapper> = ({   
    isOpen,
    setIsOpen,
    node,
    lang,
    translationValue                                                                           
                                                                            }) => {
    const {classes} = useStyles();
    const {t} = useTranslation();
    

    return (
        <Dialog
            onClose={() => {setIsOpen(false)}}
            maxWidth={"sm"}
            open={isOpen}
            className={classes.dialog}
            fullWidth={true}
        >
            <EditComponentTranslationMainView 
               isOpen={isOpen}
               setIsOpen={setIsOpen}
               node={translationValue}
               lang={lang}
             />
        </Dialog>
    )

}
export default EditComponentTranslationOverlayWrapper;